<div class="flex justify-center h-0.5 w-32 bg-gray-400">
  <div class="h-full w-1/2 bg-primary"></div>
</div>
